import { IAxiosResponseData } from '@/store';
import { axios } from '@/utils/request';

const api = `/api/Mysoft.Calendar.Common.AppServices.TaskCenterProxyAppService/`;
const api_app = '/api/pub/Mysoft.TaskCenter.TaskManager.AppServices.TaskInventoryAppService/';
const api_mobile = '/api/pub/Mysoft.TaskCenter.TaskManager.AppServices.TaskInventoryMobileAppService/';

// 【任务中心-移动端】获取任务详情
export const CenterGetTask = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api_mobile}MobileTaskCenterGetTask`, params);

// 【任务中心-移动端】接收任务
export const CenterReceiveTask = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api_mobile}MobileTaskCenterReceiveTask`, params);

// 【任务中心-移动端】-拒绝任务
export const CenterRejectTask = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api_app}RefuseTask`, params);
